const CLOUDINARY_PREFIX = 'https://fiverr-res.cloudinary.com/image/upload/';
const CLOUDINARY_ATTACHMENTS_PREFIX = 'https://fiverr-res.cloudinary.com/';
const TRANSFORMATION_XL = 'f_auto';
const TRANSFORMATION_L1 = `w_1260,${TRANSFORMATION_XL}`;
const TRANSFORMATION_L2 = `w_2520,${TRANSFORMATION_XL}`;
const TRANSFORMATION_M1 = `w_1024,${TRANSFORMATION_XL}`;
const TRANSFORMATION_M2 = `w_2048,${TRANSFORMATION_XL}`;
const TRANSFORMATION_S1 = `w_600,${TRANSFORMATION_XL}`;
const TRANSFORMATION_S2 = `w_1200,${TRANSFORMATION_XL}`;

module.exports = {
    CLOUDINARY_PREFIX,
    CLOUDINARY_ATTACHMENTS_PREFIX,
    TRANSFORMATION_XL,
    TRANSFORMATION_L1,
    TRANSFORMATION_L2,
    TRANSFORMATION_M2,
    TRANSFORMATION_M1,
    TRANSFORMATION_S1,
    TRANSFORMATION_S2
};
